/**
 * Transparent header that shows background on scroll
 */

(function() {
  const headerWrapper = document.querySelector('.header-wrapper');
  
  if (!headerWrapper) return;
  
  let lastScrollY = window.scrollY;
  
  function handleScroll() {
    const currentScrollY = window.scrollY;
    
    // Add background when scrolled past 50px
    if (currentScrollY > 50) {
      headerWrapper.classList.add('scrolled');
    } else {
      headerWrapper.classList.remove('scrolled');
    }
    
    lastScrollY = currentScrollY;
  }
  
  // Initial check
  handleScroll();
  
  // Listen to scroll
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    if (scrollTimeout) {
      window.cancelAnimationFrame(scrollTimeout);
    }
    scrollTimeout = window.requestAnimationFrame(handleScroll);
  }, { passive: true });
})();
